import { getFlavorPosts } from 'utils/api/flavors.api';
import { useQuery } from 'react-query';

function queryFn({ queryKey }) {
    return getFlavorPosts({
        category: queryKey[1].category,
        country: queryKey[1].country,
        flavor: queryKey[1].flavor,
        week: queryKey[1].week,
        year: queryKey[1].year,
        rank_type: queryKey[1].rank_type,
    });
}

export const getQueryKey = ({
    category,
    country,
    flavor,
    week,
    year,
    rank_type,
}) => {
    return [
        'flavor-tiktok-posts',
        {
            category,
            country,
            flavor,
            week,
            year,
            rank_type,
        },
    ];
};

const useFlavorPosts = ({
    category,
    country,
    flavor,
    week,
    year,
    rank_type,
    enabled = true,
}) => {
    const queryKey = getQueryKey({
        category,
        country,
        flavor,
        week,
        year,
        rank_type,
    });
    const query = useQuery(queryKey, queryFn, {
        enabled,
        staleTime: Infinity,
    });
    return query;
};

export default useFlavorPosts;
